/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TTLODelete
 */
export interface TTLODelete {
    /**
     * 
     * @type {string}
     * @memberof TTLODelete
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TTLODelete
     */
    deleted?: boolean;
}

export function TTLODeleteFromJSON(json: any): TTLODelete {
    return TTLODeleteFromJSONTyped(json, false);
}

export function TTLODeleteFromJSONTyped(json: any, ignoreDiscriminator: boolean): TTLODelete {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
    };
}

export function TTLODeleteToJSON(value?: TTLODelete | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'deleted': value.deleted,
    };
}


